import AtomicSDK from '@atomic.io/action-cards-web-sdk'

export const AtomicLastPurchase = () => {
  try {
    AtomicSDK.updateUser({
      profile: {
        flp_last_purchase: new Date().toISOString(),
      },
    })
  } catch (error) {
    console.log(error)
  }
}
